<template>
<div id="app">
    <!--
    <Cover v-if="showCover" class="coverAnimate" :class="{active:timeOut}"></Cover>-->
<!--    <Tabbar v-if="header_show"></Tabbar>-->
    <router-view v-on:header="header" v-on:footer="footer" ></router-view>
<!--     <Footer></Footer> -->
  <!-- <float-bar></float-bar> -->
</div>
</template>

<script>
import Tabbar from "@/components/TabBar/tabbar.vue";
import Footer from "@/components/Footer/footer.vue";
import FloatBar from "@/components/FloatBar/index.vue";

// import Cover from "@/components/Cover";
export default {
    name: "App",
    components: {
        // Tabbar,
      FloatBar,
        Footer,

        // Cover,
    },
    data() {
        return {
            header_show: true,
            footer_show: true,
            // isSecond: sessionStorage.getItem("isSecond"),
            // isSecond: false,
            showCover: false,
            timeOut: false,
        };
    },
    created() {
    //     const {
    //         dispatch
    //     } = this.$store;
    //     dispatch("SET_FILEIP");
    //     this.Api.getIp().then((res) => {
    //         // console.log(res, "1111")
    //         sessionStorage.setItem("picSpace", res.data);
    //         sessionStorage.setItem("picSpace", res.data);
    //     });
    },
    methods: {
      header:function (bool) {
        this.header_show=bool
      },
      footer:function (bool) {
        this.footer_show=bool
      }
    },
};
</script>

<style lang="less" scoped>
.coverAnimate {
    transition: opacity 1s;
    opacity: 1;

    &.active {
        opacity: 0;
    }
}
</style>
